export function OperatorCredibility() {
  return (
    <section className="bg-navy text-white py-10 border-y border-mint/30">
      <div className="mx-auto max-w-3xl px-6 text-center">
        <div className="h-px bg-mint/50 w-16 mx-auto mb-6" aria-hidden="true" />
        <p className="text-base sm:text-lg leading-relaxed text-white/90">
          CyLogic has operated federal cloud infrastructure for over a decade.
          CyCloud is the platform we built — managed, monitored, and continuously operated
          for customers requiring the highest level of security, compliance, and control
          over sensitive data.
        </p>
        <div className="h-px bg-mint/50 w-16 mx-auto mt-6" aria-hidden="true" />
      </div>
    </section>
  )
}
